module.exports = __webpack_public_path__ + "img/check.b04a93c6.svg";